(function () {
  if (!window.matchMedia('(min-width: 768px)').matches) return;

  function init() {
    gsap.registerPlugin(SplitText);
    document.fonts.ready.then(function() {
      document.querySelectorAll('.animated-link').forEach(function(el) {
        var wrapper = el.closest('button, a, .account-button, [class*="ai-blog-post-card-"]');
        var originalLine = el.querySelector('.text-line.original');
        var cloneLine = el.querySelector('.text-line.clone');

        if (!wrapper || !originalLine || !cloneLine) return;

        if (!originalLine._split) {
          originalLine._split = new SplitText(originalLine, { type: 'chars' });
        }
        if (!cloneLine._split) {
          cloneLine._split = new SplitText(cloneLine, { type: 'chars' });
        }

        var originalChars = originalLine._split.chars;
        var cloneChars = cloneLine._split.chars;

        wrapper.addEventListener('mouseenter', function() {
          gsap.to(originalChars, { y: '-1rem', duration: 0.6, ease: 'power2.out' });
          gsap.to(cloneChars,    { y: '-1rem', duration: 0.6, ease: 'power2.out' });
        });

        wrapper.addEventListener('mouseleave', function() {
          gsap.to(originalChars, { y: '0rem', duration: 0.6, ease: 'power2.out' });
          gsap.to(cloneChars,    { y: '0rem', duration: 0.6, ease: 'power2.out' });
        });
      });
    });
  }

  // If SplitText already loaded, run immediately
  // Otherwise wait for the script load event
  if (typeof SplitText !== 'undefined') {
    init();
  } else {
    var splitScript = document.getElementById('splittext-script');
    if (splitScript) {
      splitScript.addEventListener('load', init);
    }
  }
})();